import React from 'react';
import Portal from '../portal';
var cls = 'ab-loading-bar';
export default function LoadingBar() {
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(cls, "-bar")
  })));
}